var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { GLASS_BREAKAGE_TRAD_KEYS, GLASS_BREAKAGE_ROOM_DAMAGES_COUNT_CHOICES, GLASS_BREAKAGE_ROOM_DAMAGES_COUNT_ANSWERS, } from '@declaration/constants/glassBreakageDamageConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let GlassBreakageRoomDamagesCountQuestion = class GlassBreakageRoomDamagesCountQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
    }
    get questionTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damages-count']);
    }
    get roomDamagesCountThreshold() {
        return this.setting('bdgRoomDamagesCountThresholdBeforeExpertise');
    }
    get choices() {
        return GLASS_BREAKAGE_ROOM_DAMAGES_COUNT_CHOICES.map((choice) => {
            return {
                value: choice.value,
                label: this.$tc(choice.tradKey, this.roomDamagesCountThreshold, {
                    count: this.roomDamagesCountThreshold,
                }),
            };
        });
    }
    get selectedValue() {
        return this.qualification.roomDamagesCountAboveThreshold;
    }
    get answer() {
        if (this.qualification.roomDamagesCountAboveThreshold === null) {
            return null;
        }
        return this.$tc(this.qualification.roomDamagesCountAboveThreshold
            ? GLASS_BREAKAGE_ROOM_DAMAGES_COUNT_ANSWERS['more-than-threshold']
            : GLASS_BREAKAGE_ROOM_DAMAGES_COUNT_ANSWERS['threshold-or-less'], this.roomDamagesCountThreshold, {
            count: this.roomDamagesCountThreshold,
        });
    }
    async onUpdate(roomDamagesCountAboveThreshold) {
        this.isSaving = true;
        await this.updateAndSaveGlassBreakageDamageQualification({
            qualificationPayload: { roomDamagesCountAboveThreshold },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakageRoomDamagesCountQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakageRoomDamagesCountQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassBreakageRoomDamagesCountQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakageRoomDamagesCountQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], GlassBreakageRoomDamagesCountQuestion.prototype, "setting", void 0);
GlassBreakageRoomDamagesCountQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], GlassBreakageRoomDamagesCountQuestion);
export default GlassBreakageRoomDamagesCountQuestion;
